import { render, staticRenderFns } from "./Prefrecuentes.vue?vue&type=template&id=486f4310&scoped=true&"
import script from "./Prefrecuentes.vue?vue&type=script&lang=js&"
export * from "./Prefrecuentes.vue?vue&type=script&lang=js&"
import style0 from "./Prefrecuentes.vue?vue&type=style&index=0&id=486f4310&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486f4310",
  null
  
)

export default component.exports